import React, { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const { tokens, setLoading, clearAuth } = useAuthStore();

  useEffect(() => {
    // Check if tokens are expired on app load
    if (tokens) {
      const now = Date.now();
      if (tokens.expiresAt < now) {
        // Tokens are expired, clear auth
        clearAuth();
      }
    }
    setLoading(false);
  }, [tokens, setLoading, clearAuth]);

  return <>{children}</>;
};
